<template>
  <q-card class="my-card q-mt-md" flat bordered>
    <q-bar class="text-subtitle2">{{ title }} </q-bar>
    <q-card-section>
      <slot> </slot>
    </q-card-section>
  </q-card>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SectionWrapper',
  props: {
    title: {
      type: String,
      required: true
    }
  }
})
</script>
